import { ReactNode } from "react";
import { Container, Spinner } from "react-bootstrap";
import ResponsiveContainer from "./ResponsiveContainer";
import { SkeletonTable, SkeletonTableProps } from "./skeleton/SkeletonTable";

export type LoadingContainerProps = {
    height? : number,
    width? : number
}

export type LoadingComponentProps =
    {style: "table", styleProps: SkeletonTableProps} |
    {style: "container", styleProps: LoadingContainerProps} |
    {style: undefined, styleProps : undefined}


export default function LoadingComponent({children, condition = false, loadingProps, as, ...props} : {children? : ReactNode, condition? : boolean, loadingProps? : LoadingComponentProps, as? : React.ElementType}){
    const As = as || Container;
    return <>
        {condition ?
            (<As {...props}>{children}</As>) : renderLoader({loadingProps, ...props})
        }
    </>
}

function renderLoader({loadingProps, ...props} : {loadingProps?: LoadingComponentProps}){
    switch(loadingProps?.style){
        case "table":
            return (<SkeletonTable {...loadingProps.styleProps} {...props} />)
        case "container":
            return (<ResponsiveContainer innerContainerClassName="d-flex justify-content-center align-items-center" originalHeight={loadingProps?.styleProps?.height ?? 300} originalWidth={loadingProps?.styleProps?.width ?? 600} {...props}><Spinner/></ResponsiveContainer>)
        default:
            return (<ResponsiveContainer innerContainerClassName="d-flex justify-content-center align-items-center" originalHeight={300} originalWidth={600} {...props}><Spinner/></ResponsiveContainer>)
    }
}